<template>
  <div class="w-full overflow-x-hidden pb-28 desk:pb-3">
    <ul class="flex w-full flex-col">
      <li class="sticky top-0 z-10 w-full border-b border-gray-100 bg-gray-50">
        <a
          href="#"
          class="flex min-w-0 items-center border-l-2 px-3 py-3 text-[12px] font-semibold desk:px-4 desk:text-sm"
          :class="
            !$route.query.category && !selectedCatalog
              ? 'border-primary bg-white text-primary'
              : 'border-transparent text-gray-600 desk:hover:bg-white'
          "
          @click.prevent="selectAll"
        >
          <span class="truncate">全部商品</span>
        </a>
      </li>

      <li
        v-for="catalog in catalogs"
        :key="catalogValue(catalog)"
        class="w-full border-b border-gray-100"
      >
        <a
          href="#"
          class="flex min-w-0 items-center justify-between border-l-2 px-3 py-3 text-[12px] font-semibold desk:px-4 desk:text-sm"
          :class="
            isSelectedCatalog(catalog)
              ? 'border-primary bg-white text-primary'
              : 'border-transparent text-gray-600 desk:hover:bg-white'
          "
          @click.prevent="toggleCatalog(catalog)"
        >
          <img
            v-if="catalog.image"
            :src="cdnImage(catalog.image, 40)"
            alt=""
            class="mr-2 hidden h-5 w-5 flex-none object-contain desk:block"
            @error="applyImageFallback($event, catalog.image)"
          />
          <span class="min-w-0 flex-grow truncate pr-1 text-left leading-tight">
            {{ catalog.name }}
          </span>
          <ChevronDownIcon
            class="h-3 w-3 flex-none text-gray-400 desk:hidden"
            :class="isSelectedCatalog(catalog) ? 'rotate-180 text-primary' : ''"
          />
        </a>

        <ul
          class="w-full flex-col border-t border-gray-100 py-1"
          :class="isSelectedCatalog(catalog) ? 'flex bg-white' : 'hidden desk:flex'"
        >
          <NavigationItem
            v-for="category in catalog.children"
            :key="category.no"
            :category="category"
          />
        </ul>
      </li>
      <li class="h-28 desk:hidden"></li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ChevronDownIcon } from "@vue-hero-icons/outline";
import NavigationItem from "@/components/product/NavigationItem";
import { applyImageFallback } from "@/utils/desktopImages";

export default {
  components: {
    ChevronDownIcon,
    NavigationItem,
  },
  data() {
    return {
      selectedCatalog: null,
    };
  },
  computed: {
    ...mapGetters({
      catalogs: "app/catalogs",
    }),
  },
  watch: {
    "$route.query": {
      handler() {
        this.syncSelectedCatalog();
      },
      deep: true,
    },
    catalogs: {
      handler() {
        this.syncSelectedCatalog();
      },
      immediate: true,
    },
  },
  mounted() {
    this.syncSelectedCatalog();
  },
  methods: {
    applyImageFallback,
    syncSelectedCatalog() {
      if (!this.catalogs || this.catalogs.length === 0) return;

      const categoryNo = this.$route.query.category;
      const catalogNo = this.$route.query.catalog;

      if (categoryNo) {
        const activeCatalog = this.catalogs.find((catalog) =>
          catalog.children?.some((child) => String(this.categoryValue(child)) === String(categoryNo)),
        );
        if (activeCatalog) {
          this.selectedCatalog = this.catalogValue(activeCatalog);
          return;
        }
      }

      if (catalogNo) {
        this.selectedCatalog = catalogNo;
        return;
      }

      if (!categoryNo && !catalogNo) {
        this.selectedCatalog = null;
      }
    },
    catalogValue(catalog) {
      return catalog.no ?? catalog.id;
    },
    categoryValue(category) {
      return category.no ?? category.id;
    },
    isSelectedCatalog(catalog) {
      const value = this.catalogValue(catalog);

      return (
        value !== null &&
        value !== undefined &&
        this.selectedCatalog !== null &&
        this.selectedCatalog !== undefined &&
        String(this.selectedCatalog) === String(value)
      );
    },
    selectAll() {
      this.selectedCatalog = null;
      this.mapQuery({
        catalog: "",
        category: "",
        title: "全部商品",
      });
    },
    toggleCatalog(catalog) {
      const catalogNo = this.catalogValue(catalog);
      const isParentFilterActive =
        String(this.$route.query.catalog) === String(catalogNo) && !this.$route.query.category;

      if (isParentFilterActive) {
        this.selectedCatalog = null;
        this.mapQuery({
          catalog: "",
          category: "",
          title: "全部商品",
        });
        return;
      }

      this.selectedCatalog = catalogNo;
      this.mapQuery({
        catalog: catalogNo + "",
        category: "",
        title: catalog.name || "全部商品",
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
